import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdminUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	fill: "none",
	stroke: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		transform: "scale(1.9) translate(-6.5,-6.5)",
		d: "M13.999,19.806h5.697v-2.077c0-1.94-2.896-3.25-2.896-3.25s-1.239,1.172-2.873,1.172c-1.634,0-2.715-1.178-2.715-1.178s-2.907,1.315-2.907,3.253v2.075L13.999,19.806z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		transform: "scale(1.9) translate(-6.5,-6.5)",
		d: "M13.999,6.813c0.591,0.018,1.162,0.225,1.625,0.592c0.464,0.368,0.75,0.838,0.766,1.29l-0.298,3.406v0.019c-0.061,0.987-1.019,1.828-2.093,1.828c-1.074,0-2.038-0.84-2.094-1.834v-0.017l-0.298-3.434c0.028-0.442,0.31-0.898,0.764-1.257C12.836,7.037,13.406,6.831,13.999,6.813 M13.999,6.194c-1.393,0-2.963,1.103-3.011,2.478l0.301,3.474c0.079,1.353,1.34,2.423,2.71,2.423s2.632-1.07,2.71-2.419l0.309-3.473l0,0c-0.049-1.379-1.621-2.479-3.009-2.479L13.999,6.194z"
	})]
});
export default SvgAdminUser;
